jQuery(document).ready(function ($) {
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 50) {
      $('body').addClass('float_active');
    } else {
      $('body').removeClass('float_active');
    }
  });

  $(document).on('click', '#menu_trigger', function (event) {
    event.preventDefault();

    if ($('body').hasClass('menu_open')) {
      $('body').removeClass('menu_open');
    } else {
      $('body').addClass('menu_open');
    }
  });

  //#mobile_menu_overlay
  $(document).on('click', '#mobile_menu_overlay', function (event) {
    event.preventDefault();
    $('body').removeClass('menu_open');
  });

  $('.smooth_scroll').click(function (event) {
    event.preventDefault();
    var margintop = $(this).data('mtop') ? $(this).data('mtop') : 100;

    if ($(this.hash).length > 0) {
      $('html,body').animate({ scrollTop: $(this.hash).offset().top - margintop }, 1200);
    } else {
      var getUrl = window.location,
        url = getUrl.protocol + '//' + getUrl.host + '/' + this.hash;
      window.location = url;
    }
  });

  //PARALLAX IMAGE
  var scrolled = $(window).scrollTop(),
    ww = $(window).outerWidth();

  $('[data-parallax-bg]').each(function (i, e) {
    var image =
      ww > 992
        ? $(this).data('parallax-bg')
        : $(this).data('parallax-bg-mobile')
        ? $(this).data('parallax-bg-mobile')
        : $(this).data('parallax-bg');
    var factor = $(this).data('parallax-factor') ? $(this).data('parallax-factor') : 1.5;
    var heightFractor = $(this).data('height-factor') ? $(this).data('height-factor') : '130%';

    $(this).css('overflow', 'hidden');

    var initY = $(this).offset().top;
    var height = $(this).height();
    var diff = scrolled - initY;
    var ratio = Math.round((diff / height) * 100);

    var div = $('<div>', {
      class: 'parallax_background_inner',
      css: {
        position: 'absolute',
        top: parseInt(ratio * factor),
        left: 0,
        width: '100%',
        height: heightFractor,
        'background-image': 'url(' + image + ')',
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'z-index': -1,
      },
    });

    $(this).append(div);
  });

  function isInViewport(node) {
    var rect = node.getBoundingClientRect();

    return (
      (rect.height > 0 || rect.width > 0) &&
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  $(window).on('scroll', function () {
    var scrolled = $(window).scrollTop();

    $('[data-parallax-bg]').each(function (i, e) {
      var viewPortParent = $(this).data('viewport') ? $(this).data('viewport') : this;
      var initY = $(this).offset().top;
      var height = $(this).height();
      var factor = $(this).data('parallax-factor') ? $(this).data('parallax-factor') : 1.5;

      if (isInViewport(viewPortParent)) {
        var diff = scrolled - initY;
        var ratio = Math.round((diff / height) * 100);
        $(this)
          .children('.parallax_background_inner')
          .css('top', parseInt(ratio * factor) + 'px');
      }
    });
  });

  //popup_form
  $(document).on('click', 'a[href^="#popup_"]', function (event) {
    event.preventDefault();
    var popup = $(this).attr('href').replace('#popup_', '');
    $('#' + popup).addClass('active');
  });

  $(document).on('click', '[data-close-popup]', function (event) {
    event.preventDefault();
    var popup = $(this).closest('.popup_form');
    $(popup).removeClass('active');
  });

  //PRODUCTS CAROUSEL
  const submenu_products_carousel = new Swiper('.submenu_products_carousel', {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
      prevEl: '.carousel_nav_item_prev',
      nextEl: '.carousel_nav_item_next',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.5,
        spaceBetween: 20,
        centeredSlides: true,
      },
      640: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  //testimonials_carousel
  const testimonials_carousel = new Swiper('.testimonials_carousel', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      992: {
        slidesPerView: 1.6,
        spaceBetween: 30,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 60,
      },
    },
  });

  //video_popup
  $('.video_popup').magnificPopup({
    type: 'iframe',
    iframe: {
      preloader: false,
    },
  });

  //sort_by_trigger
  $(document).on('click', '.sort_by_trigger', function (event) {
    event.preventDefault();
    var dropdown = $(this).next('.sort_by_dropdown');
    if ($(dropdown).hasClass('open')) {
      $(dropdown).removeClass('open');
    } else {
      $(dropdown).addClass('open');
    }
  });

  /*** PRODUCT PAGE ***/
  const product_gallery_slider = new Swiper('.product_gallery_slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  //[data-gallery-thumb]
  $(document).on('click', '[data-gallery-thumb]', function () {
    var index = $(this).data('gallery-thumb');
    product_gallery_slider.slideTo(index);
  });

  //qty_plus
  $(document).on('click', '.qty_plus', function () {
    var qty = $(this).prev('.quantity-selector'),
      value = parseInt($(qty).val()),
      max = $(qty).attr('max') ? parseInt($(qty).attr('max')) : 10;

    if (value < max) {
      $(qty)
        .val(value + 1)
        .change();
    }
  });

  //qty_minus
  $(document).on('click', '.qty_minus', function () {
    var qty = $(this).next('.quantity-selector'),
      value = parseInt($(qty).val());

    if (value > 1) {
      $(qty)
        .val(value - 1)
        .change();
    }
  });

  //trigger_megamenu
  $(document).on('mouseenter', '.trigger_megamenu', function () {
    $('#merch_submenu').addClass('active');
  });

  $(document).on('mouseleave', '#merch_submenu', function () {
    $('#merch_submenu').removeClass('active');
  });

  $(document).on('click', '.close_splash_screen', function(event){
    event.preventDefault();
    $('.splash_screen_section').addClass('inactive');
  })
});
